<template>
    <el-menu class="el-menu-demo" active-text-color="#278E60" :default-active="defaultActive" mode="horizontal" router>
        <template v-for="item in navList">
                <el-menu-item :index="item.index" :key="item.index" class="el_item_me">
                    <span slot="title">{{ item.title }}<el-badge :is-dot="item.value>0" class="item"></el-badge></span>
                </el-menu-item>
        </template>
    </el-menu>
</template>

<script>
    export default {
        props: {
            navList: {
                type: Array,
                default: function () {
                    return [
                        {
                            index: "/",
                            title: "二级导航"
                        }
                    ];
                }
            },
            routerName: {
                type: String,
                default: "level2"
            }
        },
        data() {
            return {
                activeIndex: "1",
                activeIndex2: "1"
            };
        },
        computed: {
            defaultActive() {
                var arr = this.$route.path.split("/")
                return "/" + arr[1] + (arr[2] ? "/" + arr[2] : '')
            }
        },
        methods: {}
    };
</script>
<style>
    .el-menu-demo /deep/ .el-menu-item {
        height: 50px !important;
        line-height: 50px !important;
    }

    .el-menu--horizontal >>> .el-menu-item {
        height: 50px !important;
        line-height: 50px !important;
    }
</style>